package com.rainbowclubs.rainbow.data.models

import kotlinx.serialization.Serializable

@Serializable
enum class AttendeeStatus {
    YES,
    NO,
    MAYBE,
}

@Serializable
data class Attendee(
    val userId: String,
    val status: AttendeeStatus,
)

@Serializable
data class Comment(
    val commentText: String,
    val createdAt: Long, // Using Long for timestamp in shared model
    val userId: String,
    val userName: String,
)

@Serializable
data class Event(
    val id: String?,
    val clubId: String,
    val startsAt: Long,
    val endsAt: Long,
    val description: String,
    val title: String,
    val comments: List<Comment>,
    val attendees: List<Attendee>,
    val location: String? = null,
)

@Serializable
data class EventsPageResponse(
    val events: List<Event>,
    val page: Int,
    val limit: Int,
    val hasNextPage: Boolean,
)
